import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((c) => {
  if (!c.headers['X-Demo-User']) c.headers['X-Demo-User'] = localStorage.getItem('demoUser') || 'USR-ADV';
  return c;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || 'Request failed';
  return typeof d === 'string' ? d : d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join('; ');
};

export const R = (v, d = 0) => (v == null ? '—' : `R ${Number(v).toLocaleString('en-ZA', { maximumFractionDigits: d, minimumFractionDigits: d })}`);
export const Rm = (v) => {
  if (v == null) return '—';
  const a = Math.abs(v);
  if (a >= 1e6) return `R ${(v / 1e6).toFixed(1)}m`;
  if (a >= 1e3) return `R ${(v / 1e3).toFixed(0)}k`;
  return `R ${Math.round(v)}`;
};
export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-ZA'));
export const img = (k) => `/assets/${k || 'exc1'}.jpg`;
export const dt = (s) => (s ? new Date(s).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const dtt = (s) => (s ? new Date(s).toLocaleString('en-ZA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');
export const lbl = (s) => (s ? s.replace(/_/g, ' ') : '—');
export const PROV = { GP: 'Gauteng', MP: 'Mpumalanga', LP: 'Limpopo', NW: 'North West', KZN: 'KwaZulu-Natal', NC: 'Northern Cape', WC: 'Western Cape', FS: 'Free State', EC: 'Eastern Cape' };
export const C = { teal: '#00A9CE', yellow: '#FFCD00', blue: '#3B82F6', green: '#10B981', orange: '#F97316', red: '#EF4444', grid: '#1E2A45', muted: '#64748B', cyan: '#22D3EE' };
export const tip = { contentStyle: { background: '#0D1424', border: '1px solid #2B3B60', borderRadius: 6, fontSize: 12 }, labelStyle: { color: '#94A3B8' }, itemStyle: { color: '#F8FAFC' } };
export const CASE_TYPES = { service: 'Equipment service', sme_support: 'SME business support', finance_review: 'Finance review' };
export const CATEGORIES = ['Excavator', 'Wheel Loader', 'Dozer', 'Haul Truck', 'Articulated Truck', 'Motor Grader'];
